import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { Lead } from 'src/features/business/leads/schemas/lead'
import { putRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

type ArchiveReferralShareParams = {
  referralShareId: number
  archived: boolean
}

const archiveReferralShareMutation = async ({ referralShareId, archived }: ArchiveReferralShareParams) => {
  try {
    const response = await putRequest<Lead>(`/referral-shares/archive?id=${referralShareId}&archived=${archived}`)
    if (!response) return null

    return response
  } catch (error) {
    console.error('Error archiving referral share', error)
    throw error
  }
}

export const useArchiveReferralShare = () => {
  const queryClient = useQueryClient()

  return useMutation<Lead | null, Error, ArchiveReferralShareParams>({
    mutationFn: archiveReferralShareMutation,
    onSuccess: (data) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: queries.referrals.list._def })
        queryClient.invalidateQueries({ queryKey: queries.referralShares.detail(data.id).queryKey })
        queryClient.invalidateQueries({ queryKey: queries.business.list._def })
      }
    },
  })
}
